import type { ContentPage } from "@/lib/content/types";

export const reviewProcess: ContentPage = {
  slug: "process-management/review-process",
  template: "hrmsFeature",
  seo: {
    title: "Review Process Software - Add QA Steps to Your Sales | GetBiz CRM",
    description:
      "Add structured review and QA checkpoints to your sales process with GetBiz CRM, so records are checked and corrected before they move forward.",
    keywords: [
      "review process software",
      "sales QA process",
      "record review workflow",
      "data review automation",
      "CRM review process",
      "quality control CRM",
    ],
    ogImage: "/assets/data/seoimages/review-process.webp",
  },
  leaf: {
    hero: {
      caption: "Review Process",
      title: "Catch Issues Before They Move Down the Pipeline",
      description:
        "Insert structured review and QA checkpoints into your process, so records are verified, corrected and approved before they progress — protecting data quality and deal integrity.",
      h1: "caption",
    },
    split: {
      title: "Structured Review, Built Into Your Flow",
      bullets: [
        { title: "Review Checkpoints", description: "Require sign-off at key stages before progress." },
        { title: "Reviewer Queues", description: "Give reviewers a clear list of what needs attention." },
        { title: "Corrections Loop", description: "Send records back for fixes with comments." },
        { title: "Audit History", description: "Track who reviewed what, and when." },
      ],
      image: "/assets/images/img/product/crm/structured-review.webp",
      imageAlt: "GetBiz CRM review process",
    },
    cardsHeading: {
      title: "More Process Management Tools",
      description: "Review Process works with the rest of GetBiz CRM process management.",
    },
    cards: [
      { title: "Approval Process", href: "/crm-software/process-management/approval-process/", description: "Pair reviews with automated approvals.", image: "/assets/images/img/product/crm/approval-process.webp", imageAlt: "CRM approval process" },
      { title: "Validation Rule", href: "/crm-software/process-management/validation-rule/", description: "Block bad data before it reaches review.", image: "/assets/images/img/product/crm/validation-rule.webp", imageAlt: "CRM validation rule" },
      { title: "Sales Blueprint", href: "/crm-software/process-management/sales-blueprint/", description: "Embed review steps in your guided process.", image: "/assets/images/img/product/crm/sales-blueprint.webp", imageAlt: "CRM sales blueprint" },
      { title: "Multi-page Layout", href: "/crm-software/process-management/multi-page-layout/", description: "Show reviewers the right fields at the right time.", image: "/assets/images/img/product/crm/multi-page-layout.webp", imageAlt: "CRM multi-page layout" },
    ],
    testimonials: { title: "Quality at every stage", description: "See why teams add review steps in GetBiz CRM." },
    bookDemoTitle: "Add quality checks to your process.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "sales-review-process-guide, deal-review-checklist",
    metaKey: "review-process",
  },
  sections: [],
};
